import { API_SERVER, FILE_SERVER } from "../config";
import { requestForApi } from "../utils/httpUtil";

/**
 * 微信签名
 * @param url
 * @returns
 */
export async function wxsign(url: string) {
  const data = new FormData();
  data.append("url", url);
  const res = await requestForApi(`${API_SERVER}/api/v1/open/wechat/sign`, {
    data,
    method: "POST",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}

/** 定位获取地点 */
export async function placeSuggestion() {
  const res = await requestForApi(
    `${API_SERVER}/api/v1/open/map/places/location`,
    {
      method: "GET",
    }
  );
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}

export async function FileUpload(data: FormData) {
  const res = await requestForApi(`${FILE_SERVER}/api/v1/file/upload`, {
    data,
    method: "POST",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data;
}

/**
 * 获取花都小程序用户信息
 * @param token
 * @returns
 */
export async function getHdUser(token: string) {
  const res = await requestForApi(
    `/api/v1/open/wechat/huadu/user?token=${token}`,
    {
      method: "GET",
    }
  );
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}

/** 坐标转换 */
export async function locationChange(lng: number, lat: number) {
  const res = await requestForApi(
    `${API_SERVER}/api/v1/open/map/places/change?lng=${lng}&lat=${lat}`,
    {
      method: "GET",
    }
  );
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data;
}

/** 根据坐标获取地点 */
export async function place(lng: number, lat: number) {
  const res = await requestForApi(
    `/api/v1/open/map/places/address?lng=${lng}&lat=${lat}`,
    {
      method: "GET",
    }
  );
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}
